/* global G */
import { setKey } from '@gaia/util'

/**
 * Transaction Begin Flag Setter
 *
 * Should be used in conjunction with `transactionEnd` hook.
 * Will also show the loader.
 *
 * @param {Gaia.AppModule.Spec} obj - app module composition
 * @returns {function(...[*]): *[]}
 */
const transactionBegin = obj => (...args) => {
  const eventBus = obj[G.ADAPTER][G.EVENTS]
  eventBus.dispatch(eventBus.type(G.LOAD, G.INIT))

  setKey(true, G.UPDATE, obj[G.STATE])

  return args
}

export default transactionBegin
